export const safelyParseJson = <T>(value: string, defaultValue: T = undefined): T => {
    try {
        return JSON.parse(value);
    } catch (e) {
        return defaultValue;
    }
};
